import React, { FC } from 'react'
import styles from 'styles/components/button.module.scss'
import { Spacer } from 'components/Utility'
import classNames from 'classnames'

type Props = {
  accept?: string
  disabled?: boolean
  id: string
  label: string
  onSelectFile: (file: File) => void
  size?: 'basic' | 'wide'
  type: 'button' | 'text'
}

const FileUploadButton: FC<Props> = (props) => {
  const { accept = 'image/*, .heic', disabled, id, label, onSelectFile, size = 'basic', type } = props

  return (
    <label
      htmlFor={id}
      className={classNames({
        [styles.button__image]: type === 'button',
        [styles.button__image_disabled]: type === 'button' && disabled,
        [styles.button__image_wide]: type === 'button' && size === 'wide',
        [styles.button__text]: type === 'text',
        [styles.button__text_disabled]: type === 'text' && disabled,
      })}
    >
      <input
        disabled={disabled}
        id={id}
        type="file"
        accept={accept}
        onChange={(e) => {
          if (!e.target.files || e.target.files.length === 0) return
          onSelectFile(e.target.files[0])
        }}
        onClick={(e) => {
          // @ts-ignore
          e.target.value = ''
        }}
      />
      {type === 'button' && (
        <>
          <img src={'/icon/white/add.svg'} alt={label} />
          <Spacer size={4} axis={'horizontal'} />
        </>
      )}
      <span>{label}</span>
    </label>
  )
}

export default FileUploadButton
